/**
 * useAuth Hook
 *
 * Access the auth context from any component.
 * Must be used within an AuthProvider.
 */

import { useContext } from 'react'
import { AuthContext } from '@/contexts/AuthContext'

export function useAuth() {
  return useContext(AuthContext)
}
